import { Edit, useForm } from '@refinedev/antd'
import { useParams } from 'react-router-dom'
import { Form, Input, InputNumber, Switch } from 'antd'

const { TextArea } = Input

export default function CategoryEditPage() {
  const { id } = useParams()
  const { formProps, saveButtonProps } = useForm({
    resource: 'categories',
    action: 'edit',
    id,
  })

  return (
    <Edit title="Izmeni kategoriju" saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical">
        <Form.Item
          label="Naziv"
          name="name"
          rules={[{ required: true, message: 'Naziv je obavezan' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Slug (URL)"
          name="slug"
          rules={[
            { required: true, message: 'Slug je obavezan' },
            { pattern: /^[a-z0-9]+(?:-[a-z0-9]+)*$/, message: 'Samo mala slova, brojevi i crtice' },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item label="Opis" name="description">
          <TextArea rows={3} />
        </Form.Item>
        <Form.Item label="Redosled prikaza" name="sortOrder">
          <InputNumber min={0} style={{ width: '100%' }} />
        </Form.Item>
        <Form.Item label="Aktivna" name="active" valuePropName="checked">
          <Switch />
        </Form.Item>
      </Form>
    </Edit>
  )
}
